class LoadMore extends HTMLElement {
    constructor() {
        super()

        this.loadMoreButton = this.querySelector('.load-more')
        this.loadMoreButton.addEventListener('click', this.onLoadMoreClick)
    }

    static async renderPage(url) {
        const response = await fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })

        const data = await response.text()

        const parser = new DOMParser()
        const doc = parser.parseFromString(data, 'text/html')

        const newProducts = doc.getElementById('ProductGridContainer').querySelector('.product-grid')
        const newLoadMore = doc.querySelector('load-more')

        const productGrid = document.getElementById('ProductGridContainer').querySelector('.product-grid')
        productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML)

        const LoadMore = document.querySelector('load-more')
        LoadMore.replaceWith(newLoadMore)
    }

    onLoadMoreClick(event) {
        event.preventDefault()
        this.innerText = 'Loading...'
        LoadMore.renderPage(event.target.href)
    }
}

customElements.define('load-more', LoadMore)
